<div class="rfq-deadline-dialog">
  <h1 mat-dialog-title class="dialog-title">Update RFQ deadline</h1>
  <div mat-dialog-content>

    <form [formGroup]="dialogForm">
      <div class="form-field">
        <div class="label">RFQ no:</div>
        <p>{{data.rfqNumber}}</p>
      </div>
      <div class="form-field">
        <div class="label">Initial sent date:</div>
        <p>{{data.initialSentDate | date: 'dd-MMM-yy'}}</p>
      </div>
      <div class="form-field">
        <div class="label">Current RFQ deadline:</div>
        <p>{{data.rfqDeadline | date: 'dd-MMM-yy, hh:mm a'}}</p>
      </div>

      <div class="form-field mt-4">
        <div class="label pb-4">New RFQ deadline:</div>
        <div>
          <mat-form-field>
            <mat-label>dd / mm / yyyy</mat-label>
            <input matInput (change)="validateForm()" formControlName="newRFQDeadline"
              [matDatepicker]="newDeadlineDatePicker" [min]="getMinNewDeadline(data.rfqDeadline)" />
            <mat-hint>The new deadline cannot be less than 7 days after the initial send date</mat-hint>
            <mat-error *ngIf="dialogForm.controls['newRFQDeadline'].hasError('missingNewRFQDeadline')">Please fill in
              this field</mat-error>
            <mat-error *ngIf="dialogForm.controls['newRFQDeadline'].hasError('invalidNewRFQDeadline')">Date selected is
              invalid</mat-error>
            <mat-datepicker-toggle matIconSuffix [for]="newDeadlineDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #newDeadlineDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>

  <div mat-dialog-actions class="dialog-buttons">
    <app-button class="padBtn cancelBtn" name="Cancel" mat-dialog-close></app-button>
    <app-button class="padBtn actionBtn" name="Update" type="flat-button" cdkFocusInitial
      (click)="onDialogAction()"></app-button>
  </div>
</div>